import { AxiosInstance } from 'axios';

type TServiceClass<T> = new (api: AxiosInstance) => T;

export function createAPI<T extends Record<string, TServiceClass<unknown>>>(
    services: T,
    apiInstance: AxiosInstance
): { [K in keyof T]: InstanceType<T[K]> } {
    return Object.fromEntries(
        Object.entries(services).map(([key, Service]) => [key, new Service(apiInstance)])
    ) as { [K in keyof T]: InstanceType<T[K]> };
}